/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
//import * as RNLocalize from "react-native-localize";
import Immutable from "seamless-immutable"
import { NavigationActions } from 'react-navigation';
import NotificationManager from '../Lib/NotificationManager'
import { OfflineMessaging } from '../Services/OfflineMessaging'
import { deepClone } from '../Lib/utils';
/* ------------- Types and Action Creators ------------- */
const loginTypeAction = {
  authRequest: ["values"],
  authSuccess: ["response"],
  authFailure: null,
  authMode: ["mode", "code"],
  authUpdateRequest: ["user"],
  authUpdateSuccess: ["user"],
  setModeSuccess: ["ignore"],
  changePassword: ["oneTimeCode", "password", "confirmPassword"],
  changePasswordFailure: ["error"],
}

const kargoePasswordAction = {
  kargoePasswordRequest: ["values"],
  kargoePasswordSuccess: ["response"],
}
const loginFacebook = {
  facebookLoginRequest: ["data"],
  facebookLoginSuccess: ["response"],
  facebookLoginFailure: ["response"],
}
const signup = {
  signupRequest: ["data"],
  signupSuccess: ["user", "token"],
  signupFailure: ["errors"],
}
const signupFacebook = {
  facebookSignupRequest: ["data"],
  facebookSignupSuccess: ["response"],
  facebookSignupFailure: null,
}
const logoutTypeAction = {
  logoutRequest: null,
  logoutSuccess: null,
  logoutFailure: null
}
const userGroupAction = {
  getGroupRequest: null,
  groupAddUserRequest: ["UserId"],
  groupRemoveUserRequest: ["UserId"],
	groupSwitchUserRequest: ["UserId", "switchPostHints"],
  groupResult: ["GroupChanges"],
	addProfileRequest: ["screen"],
	cancelAddProfileRequest: null,
	clearAddProfileAuthBackup: null,
	updateUserAndGroup: ["user", "group"],
  switchSuccess: ["response"]
}
const { Types, Creators } = createActions({
  ...signup,
  ...signupFacebook,
  ...loginFacebook,
  ...loginTypeAction,
  ...logoutTypeAction,
	...kargoePasswordAction,
	...userGroupAction,
  renewToken: ["token"],
	setDeepLinkTask: ["deepLinkTask"],
	setMuteFunRaised: ["muteFunRaised"],
  setInfo: ["info"]
})

export const AuthTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const AUTH_BACKUP_INITIAL_STATE = {
	username: null,
	user: null,
	token: null,
	expires: null,
	meta: null,
	modified: null,	
}

export const INITIAL_STATE = Immutable({
  username: null,
  user: null,
  token: null,
  expires: null,
  meta: null,
  fetching: null,
  error: null,
  mode: null,
  oneTimeCode: null,
	modified: null,
	group: {
		currentOp: null,
		userId: null,
		fetching: null,
		error: null,
		errorCode: null,
		logRef: null,
		modified: null,
		groupId: null,
		userIds: [],
		list: [],
	},
	authBackup: AUTH_BACKUP_INITIAL_STATE,
	deepLinkTask: null,
  muteFunRaised: false,
  streamingFunRaisedDetails: null, // aka GoeFundMe
})

/* ------------- Reducers ------------- */

export const setDeepLinkTask = (state, action) => {
	console.log(`setDeepLinkTask, action: ` + JSON.stringify(action))
	const { deepLinkTask } = action
	if (!deepLinkTask)
		return state.merge({deepLinkTask})
	const params = {
		userId: deepLinkTask.UserId,
		postId: deepLinkTask.PostId
	}
	return state.merge({deepLinkTask: params})
}

export const setMuteFunRaised = (state, action) => {
	console.log(`setMuteFunRaised, action: ` + JSON.stringify(action))
	const { muteFunRaised } = action
	return state.merge({muteFunRaised})
}

export const setInfo = (state, action) => {
	console.log(`setInfo, action: ` + JSON.stringify(action))
	const { info } = action
	return state.merge(info)
}

export const getGroupRequest = (state, action) => {
	return state.merge({group: Object.assign({}, state.group, { currentOp: 'group', userId: null, fetching: true, error: null })})
}

export const groupAddUserRequest = (state, action) => {
	const { userId } = action
	return state.merge({group: Object.assign({}, state.group, { currentOp: 'addUser', userId, fetching: true, error: null })})
}

export const groupRemoveUserRequest = (state, action) => {
	const { userId } = action
	return state.merge({group: Object.assign({}, state.group, { currentOp: 'removeUser', userId, fetching: true, error: null })})
}

export const groupSwitchUserRequest = (state, action) => {
	const { userId } = action
	return state.merge({group: Object.assign({}, state.group, { currentOp: 'switchUser', userId, fetching: true, error: null })})
}

export const groupResult = (state, action) => {
	const { GroupChanges } = action
	console.log(`groupRequest groupResult GroupChanges`, GroupChanges)
	return state.merge({group: Object.assign({}, state.group, GroupChanges, {currentOp: 'none', fetching: false})})
}


export const addProfileRequest = (state, action) => {
	// record current settings for use when finishing login/signup or cancel
	console.log('addProfileRequest begins')
	console.log('addProfileRequest', state)
	const changes = Object.assign({}, {
		group: Object.assign({}, state.group, {fetching: false}),
		authBackup: { // including INITIAL_STATE causes home screen to crash
			username: state.username,
			user: state.user, // deepClone
			token: state.token,
			expires: state.expires,
			meta: state.meta, // deepClone
			modified: state.modified,	
		}
	})
	console.log('addProfileRequest changes: ' + JSON.stringify(changes))
	return state.merge(changes)
}

export const cancelAddProfileRequest = (state, action) => {
	// put things back the way they were
	console.log('cancelAddProfileRequest')
	const changes = {
		username: state.authBackup.username,
		user: state.authBackup.user,
		token: state.authBackup.token,
		expires: state.authBackup.expires,
		meta: state.authBackup.meta,
		modified: state.authBackup.modified,	
		group: Object.assign({}, state.group, {fetching: false}),
	}
	return state.merge(Object.assign({}, changes))
}

export const clearAddProfileAuthBackup = (state, action) => {
	// normal logout should call this, or successful add profile login/signup
	return state.merge(Object.assign({}, {authBackup: AUTH_BACKUP_INITIAL_STATE}))
}

export const updateUserAndGroup = (state, action) => {
	// normal logout should call this, or successful add profile login/signup
	const { user } = action
	console.log(`updateUserAndGroup action: ` + JSON.stringify(action))
	console.log(`updateUserAndGroup user: ` + JSON.stringify(user))
	return state.merge(Object.assign({}, {user}))
}

export const switchSuccess = (state, action) => {
  const { response : { data : apiResponse } } = action
  let user = apiResponse.data[0]
  const token = apiResponse.accessToken
  OfflineMessaging.init( user.UserId )
  user.Addresses = (user.Addresses || []).map((x, index) => {
    return {
      id: index,
      ...x
    }
  })
  return state.merge({
    success: true,
    fetching: false,
    error: null,
    username: user.Username,
    user: user,
    token: token,
    expires: apiResponse.expires,
    meta: apiResponse.meta,
    modified: (new Date()).getTime(),
  })
}




// request login
export const authRequest = (state, action) => {

  return state.merge({ fetching: true, error: null, success: false })
}
export const renewToken = (state, action) => {

  return state.merge({ fetching: true, error: null, success: false })
}

// successful login
export const authSuccess = (state, action) => {
  const { response : { data : apiResponse } } = action
  let user = apiResponse.data[0]
  const token = apiResponse.accessToken
  OfflineMessaging.init( user.UserId )
  user.Addresses = (user.Addresses || []).map((x, index) => {
    return {
      id: index,
      ...x
    }
  })
  return state.merge({
    success: true,
    fetching: false,
    error: null,
    username: user.Username,
    user: user,
    token: token,
    expires: apiResponse.expires,
    meta: apiResponse.meta,
    modified: (new Date()).getTime(),
  })
}


export const authFailure = (state, action) => {
  return state.merge({
    fetching: false,
    error: true,
    user: null,
    modified: (new Date()).getTime(),
  })
}
export const facebookLoginRequest = (state, action) => {

  return state.merge({ fetching: true, error: null, success: false, token: null })
}

// successful login
export const facebookLoginSuccess = (state, action) => {
  //console.log("facebookLoginSuccess action = " + JSON.stringify(action))
  const { response } = action
  const { data } = response
  const apiResponse = data
  //console.log("ready to get user, apiResponse = " + JSON.stringify(apiResponse))
  const user = (apiResponse.data && apiResponse.data.length > 0) ? apiResponse.data[0] : "user_unknown"
  //console.log("got user = " + JSON.stringify(user))
  const token = apiResponse.accessToken
  console.tron.display({
    name: 'facebookLoginSuccess',
    preview: 'You should totally expand this',
    value: {
      action: action,
      response: response,

    }
  })

  return state.merge({
    fetching: false,
    error: null,
    username: user.Username,
    user: user,
    token: token,
    expires: apiResponse.expires,
    meta: apiResponse.meta
  })
}


export const facebookLoginFailure = (state, action) => {
  const { response } = action
  console.log('facebookLoginFailure response = ' + JSON.stringify(response))
  const error = response.length > 0 ? response[0] : false
  return state.merge({
    fetching: false,
    error: error,
    user: null,
    token: null
  })
}

export const facebookSignupRequest = (state, action) => {

  return state.merge({ fetching: true, error: null, success: false, token: null })
}

// successful login
export const facebookSignupSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]
  const token = apiResponse.accessToken
  console.tron.display({
    name: 'facebookSignupSuccess',
    preview: 'You should totally expand this',
    value: {
      action: action,
      response: response,

    }
  })

  return state.merge({
    fetching: false,
    error: null,
    username: user.Username,
    user: user,
    token: token,
    expires: apiResponse.expires,
    meta: apiResponse.meta
  })
}


export const facebookSignupFailure = (state, action) => {
  return state.merge({
    fetching: false,
    error: true,
    user: null,
    token: null
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const logoutRequest = (state, action) => {
  // tell Obj C side to get rid of the screen snapshot if it exists
  // search for this string in AppDelegate.m
  NotificationManager.postNotification("AuthRedux_logoutRequest")
  return Object.assign({}, state, {
    fetching: true
  })
}

export const logoutSuccess = (state) => INITIAL_STATE


/* ------------- Kargoe password ------------- */

export const kargoePasswordRequest = (state, action) => {
  return state.merge({ error: null })
}

export const kargoePasswordSuccess = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const user = apiResponse.data[0]
  user.PinCode = true
  const token = apiResponse.accessToken

  return state.merge({
    error: null,
    username: user.Username,
    user: user,
    token: token,
    expires: apiResponse.expires,
    meta: apiResponse.meta
  })
}

/* ------------ Mode: used for locking into special pages like reset password ----------- */
export const authMode = (state, action) => {
  const { mode, code = null } = action
  console.tron.log(`AuthRedux mode: ${mode} ${code}`);
  return state.merge({ mode: mode, oneTimeCode: code })
}

export const setModeSuccess = (state, action) => {
  // console.tron.log("AuthRedux setModeSuccess");
  return state
}

export const doChangePassword = (state, action) => {
  const { oneTimeCode, password, confirmPassword } = action
  console.tron.log(`doChangePassword oneTimeCode: ${oneTimeCode}`);
  return state.merge({ fetching: true, oneTimeCode: oneTimeCode, password: password, confirmPassword: confirmPassword })
}

export const changePasswordFailure = (state, action) => {
  const { error } = action
  console.tron.log(`changePasswordFailure error: ${error}`);
  return state.merge({ fetching: false, error: error, modified: (new Date()).getTime() })
}

// ************** Standard Signup **************

export const signupRequest = (state, action) => {
  console.tron.display({name: `signupRequest`, preview : `action`, value: {action: action}})
  return state.merge({ fetching: true, error: null, success: false, token: null, user: null })
}

export const signupSuccess = (state, action) => {
  const { user, token } = action
  console.tron.display({name: `signupSuccess`, preview : `action`, value: {action: action, user: user, token: token}})
  return state.merge({ fetching: false, success: true, token, user, modified: (new Date()).getTime() })
}

export const signupFailure = (state, action) => {
  const { errors } = action
  console.tron.display({name: `signupFailure`, preview : `action`, value: {action: action, errors: errors}})
  return state.merge({ fetching: false, error: errors, modified: (new Date()).getTime() })
}

// ************** Updating user info **************

export const authUpdateRequest = (state, action) => {
  // the only call that happens as the Saga function is not necessary because we are just changing the store
  console.tron.log(`authUpdateRequest calling authUpdateSuccess`)
  return authUpdateSuccess(state, action)
}

export const authUpdateSuccess = (state, action) => {
  const { user } = action
  let newUser = Object.assign({}, state.user, user) // might be a full user record, or just a few changes
  const isLoggedInUser = state.user.UserId == user.UserId
  console.tron.display({name: `authUpdateSuccess`, preview : `detail`, value: {action: action, userChanges: user, isLoggedInUser: isLoggedInUser}})
  if (!isLoggedInUser)
    return state
  else {
    if (typeof newUser.Currency == 'undefined') {
      const currencies = ['USD'] // RNLocalize.getCurrencies()
      console.tron.display({name: `authUpdateSuccess`, preview : `need to define Currency...`, value: {currencies}})
      if (currencies.length > 0)
        newUser.Currency = currencies[0]
    }
    if (newUser.Addresses && newUser.Addresses.length)
      if (newUser.Addresses.length <= newUser.DefaultDelivery)
        newUser.DefaultDelivery = 0
    return state.merge({
      username: newUser.Username,
      user: newUser,
      modified: (new Date()).getTime()
    })
  }
}


export const reducer = createReducer(INITIAL_STATE, {
  [Types.SIGNUP_REQUEST]: signupRequest,
  [Types.SIGNUP_SUCCESS]: signupSuccess,
  [Types.SIGNUP_FAILURE]: signupFailure,

  [Types.AUTH_REQUEST]: authRequest,
  [Types.AUTH_SUCCESS]: authSuccess,
  [Types.AUTH_FAILURE]: authFailure,
  [Types.AUTH_MODE]: authMode,

  [Types.AUTH_UPDATE_REQUEST]: authUpdateRequest,
  [Types.AUTH_UPDATE_SUCCESS]: authUpdateSuccess,

  [Types.SET_MODE_SUCCESS]: setModeSuccess,

  [Types.CHANGE_PASSWORD]: doChangePassword,
  [Types.CHANGE_PASSWORD_FAILURE]: changePasswordFailure,
  [Types.LOGOUT_REQUEST]: logoutRequest,
  [Types.LOGOUT_SUCCESS]: logoutSuccess,
  [Types.LOGOUT_FAILURE]: authFailure,
  [Types.RENEW_TOKEN]: renewToken,

  [Types.KARGOE_PASSWORD_REQUEST]: kargoePasswordRequest,
  [Types.KARGOE_PASSWORD_SUCCESS]: kargoePasswordSuccess,
  [Types.FACEBOOK_LOGIN_REQUEST]: facebookLoginRequest,
  [Types.FACEBOOK_LOGIN_SUCCESS]: facebookLoginSuccess,

  [Types.FACEBOOK_LOGIN_FAILURE]: facebookLoginFailure,
  [Types.FACEBOOK_SIGNUP_REQUEST]: facebookSignupRequest,

  [Types.FACEBOOK_SIGNUP_SUCCESS]: facebookSignupSuccess,

	[Types.FACEBOOK_SIGNUP_FAILURE]: facebookSignupFailure,
	
	[Types.GET_GROUP_REQUEST]: getGroupRequest,
	[Types.GROUP_SWITCH_USER_REQUEST]: groupSwitchUserRequest,
	[Types.GROUP_ADD_USER_REQUEST]: groupAddUserRequest,
	[Types.GROUP_REMOVE_USER_REQUEST]: groupRemoveUserRequest,
	[Types.GROUP_RESULT]: groupResult,
	[Types.ADD_PROFILE_REQUEST]: addProfileRequest,
	[Types.CANCEL_ADD_PROFILE_REQUEST]: cancelAddProfileRequest,
	[Types.CLEAR_ADD_PROFILE_AUTH_BACKUP]: clearAddProfileAuthBackup,
	[Types.UPDATE_USER_AND_GROUP] : updateUserAndGroup,
  [Types.SWITCH_SUCCESS] : switchSuccess,

	[Types.SET_DEEP_LINK_TASK] :	setDeepLinkTask,
	[Types.SET_MUTE_FUN_RAISED] :	setMuteFunRaised,
	[Types.SET_INFO] :	setInfo,
})
